import React from 'react';
import cn from 'classnames';

import Card from '../Card';
import Text from '../Text';
import Button from '../Button';
import Video from '../Video';
import Share from '../Share';

import * as styles from './Conversation.module.css';
import * as textStyles from '../../styles/text.module.css';

const Conversation = ({
  headline,
  text,
  meta,
  link,
  duration,
  image,
  videoId,
  id,
  slug
}) => {
  return (
    <Card
      title="Una conversación remota"
      className={cn(styles.root)}
      animate
      id={id}
    >
      <div className={cn(styles.wrapper)}>
        <div className={cn(styles.inner)}>
          <div className={cn(styles.textWrapper)}>
            <h3 className={cn(textStyles.headline)}>{headline}</h3>
            <div className={cn(styles.info)}>
              {duration && (
                <p>
                  <strong>Duración</strong> {duration} min.
                </p>
              )}

              <Text className={cn(styles.intro)} text={meta} />
            </div>
            <Text className={cn(styles.intro)} text={text} />
          </div>
          <div className={cn(styles.videoWrapper)}>
            <Video preview={image} videoId={videoId} caption="Play Video" />

            {false && link && (
              <footer className={cn(styles.action)}>
                <Button href={link} label="Youtube" />
              </footer>
            )}
          </div>
        </div>
      </div>
      <Share
        url={`${slug}#${id}`}
        className={cn(styles.share)}
        alignTo="right"
      />
    </Card>
  );
};

export default Conversation;
